// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___1befD","open":"open___28D-X","list":"list___2qi7f","marginTop":"marginTop___2QxLN","paddingModal":"paddingModal___1dRrx"};